import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  imports: [],
  templateUrl: './error.component.html',
  standalone: true,
  styleUrl: './error.component.sass'
})
export class ErrorComponent {

}
